import React from "react";
import PropTypes from "prop-types";
import { TvDiv, TvH5, TvP, TvSmall } from "@trustvid/design-system";

const LoginFeatureGrid = ({ sections, columns = 3, compact = false }) => (
  <TvDiv className="tv-login-page__feature-sections d-flex flex-column">
    {sections.map((section) => (
      <TvDiv
        key={section.title}
        className={`tv-login-page__feature-block rounded-4${compact ? " tv-login-page__feature-block--compact" : ""}`}
      >
        <TvH5 className="tv-login-page__feature-title fw-semibold text-white">{section.title}</TvH5>
        <TvDiv
          className={`tv-login-page__feature-grid tv-login-page__feature-grid--cols-${columns}${compact ? " tv-login-page__feature-grid--compact" : ""}`}
          data-testid="login-feature-row"
        >
          {section.items.map((item) => (
            <TvDiv
              key={item.title}
              className="tv-login-page__feature-item d-flex flex-column align-items-center text-center rounded-3"
              data-testid={item.title === "Asset library" ? "login-feature-asset-library" : undefined}
            >
              <TvDiv
                className="tv-login-page__feature-icon flex-shrink-0 rounded-circle d-flex align-items-center justify-content-center"
                aria-hidden="true"
              >
                <i className={`mdi ${item.icon}`} />
              </TvDiv>
              <TvP className="tv-login-page__feature-item-title fw-semibold mb-0">{item.title}</TvP>
              <TvSmall className="tv-login-page__feature-item-desc mb-0">{item.description}</TvSmall>
            </TvDiv>
          ))}
        </TvDiv>
      </TvDiv>
    ))}
  </TvDiv>
);

LoginFeatureGrid.propTypes = {
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      items: PropTypes.arrayOf(
        PropTypes.shape({
          icon: PropTypes.string.isRequired,
          title: PropTypes.string.isRequired,
          description: PropTypes.string.isRequired,
        })
      ).isRequired,
    })
  ).isRequired,
  columns: PropTypes.oneOf([1, 2, 3]),
  compact: PropTypes.bool,
};

export default LoginFeatureGrid;
